import { Pipe, PipeTransform } from '@angular/core';
import { Category, ICategoryDataV3 } from '@df/catalog/category/category';
import { Gtm } from '@df/module-gtm/event/gtm.event';

/**
 * converts any data to address model
 */

@Pipe({
    name: 'gtmCategoryToList',
    standalone: true
})
export class GtmCategoryToListPipe implements PipeTransform {
    transform(category: Category<ICategoryDataV3>): Gtm.List {
        return {
            listId: `category_${category.id}`,
            listName: category.data?.breadcrumbs?.map(i => i.label).join(' > ') || category.name
        };
    }
}
